var _a;
export var BOARD_TYPE;
(function (BOARD_TYPE) {
    BOARD_TYPE["MAIN"] = "MAIN";
    BOARD_TYPE["VOD"] = "VOD";
    BOARD_TYPE["MOVIE"] = "MOVIE";
    BOARD_TYPE["PARAMOUNT"] = "PARAMOUNT";
    BOARD_TYPE["HISTORY"] = "HISTORY";
    BOARD_TYPE["SEARCH"] = "SEARCH";
})(BOARD_TYPE || (BOARD_TYPE = {}));
export var BOARD_NAME_MAP = (_a = {},
    _a[BOARD_TYPE.MAIN] = '홈',
    _a[BOARD_TYPE.VOD] = '시리즈',
    _a[BOARD_TYPE.MOVIE] = '영화',
    _a[BOARD_TYPE.PARAMOUNT] = '파라마운트+',
    _a[BOARD_TYPE.HISTORY] = '기록',
    _a[BOARD_TYPE.SEARCH] = '검색',
    _a);
